import React, { useRef, useState, useEffect } from "react";
import ReactCardCarousel from "react-card-carousel";
import bgInstitucional from "../../assets/images/bgInstitucional.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {faArrowCircleLeft, faArrowCircleRight, faArrowLeft, faArrowRight} from "@fortawesome/free-solid-svg-icons";



const SliderRender = ({ jsonConfig,backgroundColor }) => {
    const containerRef = useRef(null);
    const carouselRef = useRef(null);
    const [dimensions, setDimensions] = useState({ width: 0, height: 0 });
    const [clicked, setClicked] = useState(false);

    const enviarMensaje = (tipo, data) => {
        const manager = window.VTWidgetBridge.Bridge.raiseEvent(tipo, data);
        console.log(tipo);
        console.log(data);
        console.log(manager);
    };

    useEffect(() => {
        const updateSize = () => {
            if (containerRef.current) {
                const { clientWidth, clientHeight } = containerRef.current;
                setDimensions({ width: clientWidth, height: clientHeight });
            }
        };

        // Usamos ResizeObserver para detectar cambios en el tamaño del contenedor
        const resizeObserver = new ResizeObserver(updateSize);
        if (containerRef.current) {
            resizeObserver.observe(containerRef.current);
        }

        // Cleanup al desmontar
        return () => resizeObserver.disconnect();
    }, []);

    //var cards = JSON.parse(jsonConfig).filter(card => card.code !== 'ZERO').filter(card => card.code !== 'BJOVEN');
    var cards = JSON.parse(jsonConfig);

/*
    var cards = [
        {
            "code":"DEFAULT",
            "image":"https://vxapp.wfsystems.com.ar/storage/logos/20250222103153.png",
            "logo":"https://vxapp.wfsystems.com.ar/storage/logos/20250318110131.png",
            "text":"",
            "textSize":20,
            "btnPrimaryExist":true,
            "btnPrimarycolor":"#070DFA",
            "btnPrimaryHash":"DEFAULT_QR",
            "btnPrimaryText":"Try our Innovation Laboratory",
            "btnSecondaryExist":false,
            "btnSecondarycolor":"",
            "btnSecondaryHash":"",
        },
        {
            "code":"SCAN_QR",
            "image":"https://vxapp.wfsystems.com.ar/storage/logos/20250318110605.png",
            "logo":"https://vxapp.wfsystems.com.ar/storage/logos/20250318110131.png",
            "text":"",
            "textSize":20,
            "btnPrimaryExist":true,
            "btnPrimarycolor":"#070DFA",
            "btnPrimaryHash":"SCAN_QR",
            "btnPrimaryText":"Try your own app!",
            "btnSecondaryExist":true,
            "btnSecondarycolor":"#070DFA",
            "btnSecondaryHash":"LAST_QR",
            "btnSecondaryText":"Re-open the last experience",
        },
        {
            "code":"BANORTE",
            "image":"https://vxapp.wfsystems.com.ar/storage/logos/20250222102905.png",
            "logo":"https://vxapp.wfsystems.com.ar/storage/logos/20250222100840.png",
            "text":"",
            "textSize":20,
            "textColor":"#ED0029",
            "btnPrimaryExist":true,
            "btnPrimarycolor":"#ED0029",
            "btnPrimaryHash":"D39409D148AC99A83AF11258E9AB7FC0DB8FC1BE",
            "btnPrimaryText":"Try our Retail Banking Experience",
            "btnSecondaryExist":false,
            "btnSecondarycolor":"",
            "btnSecondaryHash":"",
        },
        {
            "code":"CDNI",
            "image":"https://vxapp.wfsystems.com.ar/storage/logos/20250222102927.png",
            "logo":"https://vxapp.wfsystems.com.ar/storage/logos/20250222100903.png",
            "text":"",
            "textSize":20,
            "textColor":"#FFF",
            "btnPrimaryExist":true,
            "btnPrimarycolor":"#279D2E",
            "btnPrimaryHash":"B5030390E178A6006B2F19E9C193CB699813FBE7",
            "btnPrimaryText":"Try our Retail Wallet Experience",
            "btnSecondaryExist":false,
            "btnSecondarycolor":"",
            "btnSecondaryHash":"",
        },

        {
            "code":"MCITY",
            "image":"https://vxapp.wfsystems.com.ar/storage/logos/20250222100448.png",
            "logo":"https://vxapp.wfsystems.com.ar/storage/logos/20250222103700.png",
            "text":"",
            "textSize":20,
            "textColor":"#FFFFFF",
            "btnPrimaryExist":true,
            "btnPrimarycolor":"#070DFA",
            "btnPrimaryHash":"7B9C0F7844D83294A0975ABFF2187391D2B422F0",
            "btnPrimaryText":"Try our FAN Enrollment Experience",
            "btnSecondaryExist":true,
            "btnSecondarycolor":"#070DFA",
            "btnSecondaryHash":"7B9C0F7844D83294A0975ABFF2187391D2B422F0_SCANNER",
            "btnSecondaryText":"Try our Ticket Validator Experience",
        },

        {
            "code":"COLUMBIA",
            "image":"https://vxapp.wfsystems.com.ar/storage/logos/20250413184022.png",
            "logo":"https://vxapp.wfsystems.com.ar/storage/logos/20250321142655.png",
            "text":"",
            "textSize":20,
            "textColor":"#FFFFFF",
            "btnPrimaryExist":true,
            "btnPrimarycolor":"#052d75",
            "btnPrimaryHash":"194732863F3EEF35BE3F0851AC804A6AEFD7FFFC",
            "btnPrimaryText":"Try our Wallet experience",
            "btnSecondaryExist":false,
            "btnSecondarycolor":"#052d75",
            "btnSecondaryHash":"",
            "btnSecondaryText":"",
        },



    ];
*/



    return (
        <div ref={containerRef} style={{
            ...styles.containerStyle,
            backgroundColor: backgroundColor
        }}>
            <ReactCardCarousel ref={carouselRef} spread="narrow" autoplay={false} autoplay_speed={2000}>
                {cards.map((card, index) => {
                    if(card.code == "SPORT_SCANNER"){
                        return (<div style={{
                            ...getCardStyles(dimensions),
                            position: 'relative',
                            borderRadius:20,
                        }}>

                            {/* Left Gradient */}
                            <div
                                style={{
                                    position: 'absolute',
                                    top: 0,
                                    left: 0,
                                    borderTopLeftRadius:20,
                                    borderBottomLeftRadius:20,
                                    width: '100%',
                                    height: '100%',
                                    background: `linear-gradient(to bottom, ${card.colorPrimaryLeft} 0%, ${card.colorPrimaryLeft} 60%, #FFFFFF 100%)`,
                                    clipPath: 'polygon(0 0, 45% 0, 60% 100%, 0% 100%)',
                                }}
                            />




                            {/* Contenido */}
                            <div
                                style={{
                                    position: 'absolute',
                                    top:0,
                                    left:0,
                                    width: '100%',
                                    height: '100%',
                                    zIndex: 10,
                                    padding: '2rem',
                                    backgroundColor: 'transparent',
                                    display:'flex',
                                    flexDirection:'column',
                                    alignItems:'center',
                                    justifyContent:'space-around',
                                }}>

                                {/* NOMBRES */}
                                <div style={{
                                    marginTop: 10,
                                    width: '100%',
                                    display: 'flex',
                                    flexDirection: 'row',
                                    justifyContent: 'space-around',
                                    maxHeight: 100,
                                }}>
                                    <span style={{
                                        width: '50%',
                                        textAlign: 'center',
                                        color: '#FFFFFF',
                                        fontSize: 16,
                                        fontWeight: 'bold'}}> {card.nameLeft} </span>
                                    <span style={{
                                        width: '50%',
                                        textAlign: 'center',
                                        color: '#FFFFFF',
                                        fontSize: 16,
                                        fontWeight: 'bold'}}> {card.nameRight} </span>
                                </div>

                                {/* LOGOS */}
                                <div style={{
                                    marginTop: 10,
                                    width: '100%',
                                    display:'flex',
                                    flexDirection:'row',
                                    justifyContent:'space-around',
                                    maxHeight:100,
                                }}>
                                    <img src={card.logoLeft} style={{width: '33%', objectFit: 'contain'}}/>
                                    <img src={card.logoRight} style={{width: '33%', objectFit: 'contain'}}/>
                                </div>

                                {/* SHIRTS */}
                                <div style={{
                                    marginTop: 10,
                                    width: '100%',
                                    display:'flex',
                                    flexDirection:'row',
                                    justifyContent:'space-around',
                                    maxHeight:500,
                                }}>
                                    <img src={card.shirtLeft} style={{width: '50%', objectFit: 'contain'}}/>
                                    <img src={card.shirtRight} style={{width: '50%', objectFit: 'contain'}}/>
                                </div>

                                {/* INFO */}
                                <div style={{
                                    marginTop: 10,
                                    width: '100%',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    justifyContent: 'space-around',
                                }}>

                                    <span style={{
                                        textAlign: 'center',
                                        color: '#FFFFFF',
                                        fontSize: 17,
                                        fontWeight: 'bold'
                                    }}> {card.location} </span>

                                    <span style={{
                                        textAlign: 'center',
                                        color: '#FFFFFF',
                                        fontSize: 14,
                                        fontWeight: 'bold'
                                    }}> {card.date} {card.time} </span>


                                </div>

                                {/* BUTTON */}
                                <div style={{
                                    marginTop: 10,
                                    width: '100%',
                                    display: 'flex',
                                    flexDirection: 'row',
                                    justifyContent:'space-around',
                                    maxHeight:500,
                                }}>
                                    <button
                                        id={"btnTryMe"}
                                        className={'btn-tryme'}
                                        style={getCardButtonPrimaryStyles(dimensions, card)}
                                        onClick={() =>{
                                            enviarMensaje("vtOnClick", {vtHash: card.eventId })}}>
                                        Start to Scan
                                    </button>
                                </div>


                            </div>


                        </div>)
                    } else {
                        return (
                            <div style={{
                                ...getCardStyles(dimensions),
                                position: 'relative',

                            }}>
                                <img
                                    src={card.image}
                                    style={{
                                        width: '100%',
                                        height: '100%',
                                        objectFit: 'cover',
                                        position: 'absolute',
                                        objectPosition: "center",
                                        top: 0,
                                        left: 0,
                                        borderTopLeftRadius: 20,
                                        borderTopRightRadius: 20,
                                        borderBottomLeftRadius: 20,
                                        borderBottomRightRadius: 20,
                                        zIndex: 0
                                    }}
                                />

                                {/* Contenedor del logo y el texto */}
                                <div style={{
                                    height: '50%',
                                    paddingTop: '10%',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    flex: 1,
                                    alignItems: 'center',
                                    justifyContent: 'flex-end',
                                    backgroundImage: `linear-gradient(to bottom, rgba(0, 0, 0, 0) 0%, ${card.colorPrimary} 60%)`,
                                    borderTopLeftRadius: 20,
                                    borderTopRightRadius: 20,
                                    borderBottomLeftRadius: 20,
                                    borderBottomRightRadius: 20,
                                    paddingBottom: 5,
                                    zIndex: 1 // 🔥 Está por encima de la imagen
                                }}>

                                    <span style={getCardSpanStyles(dimensions, card)}>{card.text}</span>

                                    {card.logo != "" &&
                                        <img src={card.logo} style={getCardLogoStyles(dimensions)}/>
                                    }

                                    {card.btnPrimaryExist &&
                                        <button
                                            id={"btnTryMe"}
                                            className={'btn-tryme'}
                                            style={getCardButtonPrimaryStyles(dimensions, card)}
                                            onClick={() =>{
                                                setClicked(!clicked);
                                                enviarMensaje("vtOnClick", {vtHash: card.btnPrimaryHash })}}>
                                            {card.btnPrimaryText}
                                        </button>}

                                    {card.btnSecondaryExist &&
                                        <button
                                            id={"btnTryMe"}
                                            className={'btn-tryme'}
                                            style={getCardButtonSecondaryStyles(dimensions, card)}
                                            onClick={() =>{
                                                setClicked(!clicked);
                                                enviarMensaje("vtOnClick", {vtHash: card.btnSecondaryHash })}}>
                                            {card.btnSecondaryText}
                                        </button>}
                                    {!card.btnSecondaryExist &&
                                        <div style={{height:40, width:'100%'}}></div>}

                                </div>
                            </div>

                        )
                    }
                })}
            </ReactCardCarousel>

            <button style={{position: 'absolute',left:20, zIndex: 10000, fontSize: 50}} onClick={() => carouselRef.current.prev()}>
                <FontAwesomeIcon icon={faArrowCircleLeft} size={100} color='#C4C4C4'/>
            </button>

            <button style={{position: 'absolute', right: 20, zIndex: 10000, fontSize: 50}} onClick={() => carouselRef.current.next()}>
                <FontAwesomeIcon icon={faArrowCircleRight} size={100} color='#C4C4C4'/>
            </button>
        </div>
    );
};

// Función para calcular el estilo dinámico de las cards
const getCardStyles = (dimensions) => ({
    height: dimensions.height * 0.95 || "95%",
    width: dimensions.width * 0.7 || "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "flex-end",
    backgroundColor: '#FFF',
    borderTopLeftRadius: 20,
    borderTopRightRadius: 20,
    borderBottomLeftRadius: 20,
    borderBottomRightRadius: 20,
});

const getCardSpanStyles = (dimensions,card) => ({
    fontSize: card.textSize || 20,
    width: '80%',
    textAlign:'center',
    fontFamily: "Open Sans",
    textTransform: "uppercase",
    fontWeight: "bold",
    color: card.textColor || "#FFF",
    height:60,
});

const getCardLogoStyles = (dimensions) => ({
    //height: dimensions.width * 0.25,
    width: dimensions.width * 0.25,
    objectFit: 'contain',
    margin:10,
});

const getCardButtonPrimaryStyles = (dimensions, card) => ({
    height: 40,
    width: '80%',
    backgroundColor: card.btnPrimarycolor,
    color: '#FFF',
    borderStyle: 'solid',
    borderColor: card.btnPrimarycolor,
    borderWidth: 1,
    borderRadius: 7,
    marginTop: 2,
    marginBottom: 2,
    fontSize: 10,
    fontWeight: 'bold',
    fontFamily: 'Open Sans',
});

const getCardButtonSecondaryStyles = (dimensions, card) => ({
    height: 40,
    width: '80%',
    backgroundColor: '#FFF',
    color: card.btnSecondarycolor,
    borderStyle: 'solid',
    borderColor: card.btnSecondarycolor,
    borderWidth: 1,
    borderRadius: 7,
    fontSize: 10,
    marginTop: 2,
    marginBottom: 2,
    fontFamily: 'Open Sans',
});

const getCardButtonLegendStyles = (dimensions, card) => ({
    height: 40,
    width: '80%',
    backgroundColor: 'transparent',
    color: card.btnSecondarycolor,
    textDecoration: 'underline',
    fontWeight: 'bold',
    borderStyle: 'none',
    borderRadius: 7,
    marginTop: 2,
    marginBottom: 2,
    fontFamily: 'Open Sans',
});



const styles = {
    containerStyle: {
        width: "100%",
        height: "100%",
        display: "flex",
        flex: 1,
        justifyContent: "center",
        alignItems: "center",
        position: "relative",
        backgroundColor: '#0A172C',
        backgroundSize: "cover",   // Para que cubra todo el contenedor
        backgroundPosition: "center", // Centrar la imagen
        backgroundRepeat: "no-repeat", // Evitar repeticiones
    },
};

export default SliderRender;
